export default __webpack_public_path__ + "static/media/done-check.f00fe9a5.svg";